import axios from 'axios'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    carDocuments: null,
    driverDocuments: null,
  },
  getters: {
    carDocuments: state => state.carDocuments,
    driverDocuments: state => state.driverDocuments,
  },
  mutations: {
    SET_CARS_DOCUMENTS: (state, documents) => { state.carDocuments = documents },
    SET_DRIVERS_DOCUMENTS: (state, documents) => { state.driverDocuments = documents },
  },
  actions: {
    getPresignedUrl(ctx, {
      name, documentType, driverId, carId, extension,
    }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('/documents/', {
            name, documentType, driverId, carId, extension,
          })
          .then(response => {
            resolve(response.data.data)
          })
          .catch(error => reject(error))
      })
    },
    fetchDocuments({ commit }, { type, typeId }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/${type}/${typeId}/documents`)
          .then(response => {
            resolve(response.data.data)
            commit(`SET_${type.toUpperCase()}_DOCUMENTS`, response.data.data)
          })
          .catch(error => reject(error))
      })
    },
    validateDriverDocument(_, { driverId, documentId }) {
      return axiosIns.patch(`/drivers/${driverId}/documents/${documentId}`)
    },
    async s3Upload(ctx, { url, file }) {
      return axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      })
    },
    handleDocumentStatus(_, { driverId, documentId, status }) {
      console.log('store......')
      return axiosIns.patch(`/drivers/${driverId}/documents/${documentId}`, {
        status,
      })
    },
  },
}
